import { useEffect } from "react";
import logo_white from "../../assets/logo.png";
import ic_exercise from "../../assets/icons/ic_exercise.svg";
import ic_exercise_red from "../../assets/icons/ic_exercise_red.svg";
import { Fragment, useState } from "react";
import AuthDialog from "../auth/AuthDialog";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../context/AuthContext";
import { Dialog, Popover, Transition, Listbox } from "@headlessui/react";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import { useAppContext } from "../../context/AppContext";
import { getProfile } from "../../api/api";
import queryString from "query-string";
import Cookies from "js-cookie";
import {
  BlueLinearGradient,
  BlueTextLinearGradient,
  WhiteLinearGradient,
  WhiteTextLinearGradient,
} from "../../utils/Utils";

function Header() {
  const auth = useAuthContext();
  const [showAuthDialog, setShowAuthDialog] = useState(false);
  const [dropdownSelected, setDropdownSelected] = useState("");
  const [clickFrom, setClickFrom] = useState("");

  // get landingURL from Cookies
  const landingUrl = Cookies.get("currentUrl");

  const location = useLocation();
  const navigate = useNavigate();
  const [profile, setProfile] = useState({});

  // Get-Dynamic Page-Name through URL
  const { pathname } = useLocation();
  const segments = pathname.split("/");
  const lastSegment = segments[segments.length - 1];
  let modifiedSegment;
  if (lastSegment === "programpage") {
    modifiedSegment = "Workouts";
  } else if (lastSegment === "practice") {
    modifiedSegment = "Exercises";
  } else {
    modifiedSegment = lastSegment;
  }

  // User Profile Data (mins, workouts, streaks)
  async function updateProfile() {
    let response = await getProfile();
    if (response) {
      setProfile(response);
    } else {
      // toast("Error fetching profile details", { type: "error" });
    }
  }
  // congratulatory message after completing 1st streak
  if (profile.streak === 1) {
    toast("Congratulation, you have completed your first streak");
  }

  function HeaderElement({
    icon,
    iconSelected,
    iconEnd,
    title,
    selectionPage,
    onClick,
  }) {
    return (
      <button
        className="h-full space-x-3 text-xl text-primary-white hover:text-black-400 flex items-center justify-center font-medium active:text-black-400 focus:outline-none"
        onClick={onClick}
      >
        {title && <p className={`focus:outline-none`}>{title}</p>}
      </button>
    );
  }

  const [selected, setSelected] = useState(false);
  const [mobileMenuClose, setMobileMenuClose] = useState(false);
  const appState = useAppContext();
  const [showFullHeaderMenu, setShowFullHeaderMenu] = useState(false);
  const [answer, setAnswer] = useState("");
  const [scrollPricing, setScrollPricing] = useState(true);
  const [showReshcedule, setShowReshcedule] = useState(false);
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [mobile, setMobile] = useState();
  const [dob, setDob] = useState();

  useEffect(() => {
    updateProfile();
    // hashLocation();
  }, [auth.state]);

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    return scrollPricing;
  }, []);

  // Tracking Function 'queryString'
  const trackingPoint = () => {
    const queryParams = queryString.stringify({
      ref: "nav_login",
    });
    navigate(`newLogin/?${queryParams}`);
  };

  return (
    <div
      className={`flex flex-row w-full h-16 
      ${
        auth.state.user
          ? "bg-primary-white dark:bg-[#25272D]"
          : "bg-primary-midBlack bg-opacity-90"
      } px-5 md:px-16 lg:px-24 2xl:px-32 items-center`}
    >
      <Link
        to={auth.state.user ? "/programpage" : "/"}
        className="hidden md:flex items-center py-4"
      >
        <img
          src={logo_white}
          //   !auth.state.user
          //     ? logo_white
          //     : appState.state.darkMode
          //     ? logo_white
          //     : logo
          // }
          className="h-12"
        />
      </Link>
      <Link
        to={auth.state.user ? "/programpage" : "/"}
        className="md:hidden flex items-center py-4"
      >
        <img
          src={logo_white}
          //   !auth.state.user
          //     ? logo_white
          //     : appState.state.darkMode
          //     ? mob_logo
          //     : logo
          // }
          className={`${!auth.state.user ? "h-10" : "h-10"} `}
          // className={`${!auth.state.user ? "block" : "hidden"} h-10`}
        />
      </Link>
      {location.pathname === "/login" ? null : !auth.state.user ? (
        <>
          <div className="hidden lg:flex flex-1 space-x-10 items-center justify-end">
            <div
              className="text-white cursor-pointer text-sm hover:text-primary-neonGreen"
              onClick={() => {
                if (location.pathname != "/") {
                  window.location.href =
                    window.location.protocol +
                    "//" +
                    window.location.host +
                    "/#section-how-it-works";
                  // navigate("/#how-it-works");
                  return;
                }
                document.getElementById("section-how-it-works").scrollIntoView({
                  behavior: "smooth",
                });
              }}
              id="heading-how-it-works"
            >
              {/* Wellness */}
              Fitness Tests
            </div>
            <div
              className="text-white cursor-pointer text-sm hover:text-primary-neonGreen"
              onClick={() => {
                navigate("/about-us");
              }}
            >
              About us
            </div>
            {/* <div
              className="text-white cursor-pointer text-sm hover:text-primary-neonGreen"
              onClick={() => {
                navigate("/fitnessage");
              }}
            >
              Fitness Age
            </div> */}
            <div
              className="text-white cursor-pointer text-sm hover:text-primary-neonGreen"
              onClick={() => {
                if (location.pathname != "/") {
                  navigate("/#features");
                  return;
                }
                document.getElementById("section-features").scrollIntoView({
                  behavior: "smooth",
                });
              }}
              id="heading-features"
            >
              Features
            </div>
            <div
              className="text-white cursor-pointer text-sm hover:text-primary-neonGreen"
              onClick={() => {
                if (location.pathname != "/") {
                  navigate("/#cohorts");
                  return;
                }
                document.getElementById("section-cohorts").scrollIntoView({
                  behavior: "smooth",
                });
              }}
              id="heading-cohorts"
            >
              Is it for you?
            </div>
            <div
              className="text-white cursor-pointer text-sm hover:text-primary-neonGreen"
              onClick={() => {
                if (location.pathname != "/") {
                  navigate("/#comparisons");
                  return;
                }
                document.getElementById("section-comparison").scrollIntoView({
                  behavior: "smooth",
                });
              }}
              id="heading-comparison"
            >
              Compare
            </div>

            {/* Pricing Page */}
            <div
              className="text-white cursor-pointer text-sm hover:text-primary-neonGreen"
              onClick={() => {
                navigate("/subscription");
                // return window.scrollTo(0, 0);
                setScrollPricing(true);
              }}
            >
              Pricing
            </div>

            <div
              className="text-black cursor-pointer text-sm rounded bg-primary-neonGreen px-5 py-2"
              // onClick={() => {
              //   setShowAuthDialog(true);
              // }}
              onClick={() => {
                setClickFrom("nav_login");
                trackingPoint();
                // navigate("newLogin");
              }}
            >
              Login
            </div>
          </div>
          <div className="flex flex-1 md:hidden" />
          <Icon
            icon="ci:hamburger"
            className="flex lg:hidden align-middle text-primary-neonGreen w-8 h-8"
            onClick={() => {
              setShowFullHeaderMenu(true);
            }}
          />
          <Transition.Root
            show={showFullHeaderMenu}
            as={Fragment}
            className={`${
              appState.state.darkMode ? "dark" : " "
            } relative z-30`}
          >
            <Dialog as="div" className="relative z-10" onClose={() => {}}>
              <div className="fixed inset-0 overflow-hidden">
                <div className="absolute inset-0 overflow-hidden">
                  <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
                    <Transition.Child
                      as={Fragment}
                      enter="transform transition ease-in-out duration-300"
                      enterFrom="translate-x-full"
                      enterTo="translate-x-0"
                      leave="transform transition ease-in-out duration-300"
                      leaveFrom="translate-x-0"
                      leaveTo="translate-x-full"
                    >
                      <Dialog.Panel className="pointer-events-auto relative w-screen max-w-md">
                        <Transition.Child
                          as={Fragment}
                          enter="ease-in-out duration-300"
                          enterFrom="opacity-0"
                          enterTo="opacity-100"
                          leave="ease-in-out duration-300"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                        >
                          <div
                            className={`flex h-full flex-col shadow-xl w-full bg-primary-midBlack p-8`}
                          >
                            <div className="flex flex-row items-center">
                              <Link to={"/"} className="flex items-center py-4">
                                <img
                                  src={logo_white}
                                  //   !auth.state.user
                                  //     ? logo_white
                                  //     : appState.state.darkMode
                                  //     ? logo_white
                                  //     : logo
                                  // }
                                  className="h-10"
                                  onClick={() => {
                                    setShowFullHeaderMenu(false);
                                  }}
                                />
                              </Link>
                              <div className="flex flex-1 md:hidden" />
                              <Icon
                                icon="akar-icons:cross"
                                className="flex align-middle text-primary-neonGreen w-6 h-6"
                                onClick={() => {
                                  setShowFullHeaderMenu(false);
                                }}
                              />
                            </div>

                            {/* Mobile Header */}
                            <div className="flex flex-col flex-1 gap-5 mt-10">
                              <div
                                className="text-white cursor-pointer text-lg font-medium"
                                onClick={() => {
                                  if (location.pathname != "/") {
                                    navigate("/#section-how-it-works");
                                    setShowFullHeaderMenu(false);
                                    return;
                                  }
                                  document
                                    .getElementById("section-how-it-works")
                                    .scrollIntoView({
                                      behavior: "smooth",
                                    });
                                  setShowFullHeaderMenu(false);
                                }}
                                id="heading-how-it-works"
                              >
                                {/* Wellness */}
                                Fitness Test
                              </div>
                              <div
                                className="text-white cursor-pointer text-lg font-medium"
                                onClick={() => {
                                  navigate("/about-us");
                                  setShowFullHeaderMenu(false);
                                  return;
                                }}
                              >
                                About us
                              </div>
                              <div
                                className="text-white cursor-pointer text-lg font-medium"
                                onClick={() => {
                                  if (location.pathname != "/") {
                                    navigate("/#features");
                                    setShowFullHeaderMenu(false);
                                    return;
                                  }
                                  document
                                    .getElementById("section-features")
                                    .scrollIntoView({
                                      behavior: "smooth",
                                    });
                                  setShowFullHeaderMenu(false);
                                }}
                              >
                                Features
                              </div>
                              <div
                                className="text-white cursor-pointer text-lg font-medium"
                                onClick={() => {
                                  if (location.pathname != "/") {
                                    navigate("/#cohorts");
                                    setShowFullHeaderMenu(false);
                                    return;
                                  }
                                  // navigate("/#cohorts");
                                  // setShowFullHeaderMenu(false);
                                  document
                                    .getElementById("section-cohorts")
                                    .scrollIntoView({
                                      behavior: "smooth",
                                    });
                                  setShowFullHeaderMenu(false);
                                  return;
                                }}
                              >
                                Is it for you?
                              </div>

                              {/* <div
                                className="text-white cursor-pointer text-lg font-medium"
                                onClick={() => {
                                  if (location.pathname != "/") {
                                    navigate("/#comparisons");
                                    setShowFullHeaderMenu(false);
                                    return;
                                  }
                                  document
                                    .getElementById("section-comparison")
                                    .scrollIntoView({
                                      behavior: "smooth",
                                    });
                                  setShowFullHeaderMenu(false);
                                  return;
                                }}
                              >
                                Compare
                              </div> */}

                              <div
                                className="text-white cursor-pointer text-lg font-medium"
                                onClick={() => {
                                  navigate("/subscription");
                                  setShowFullHeaderMenu(false);
                                }}
                              >
                                Pricing
                              </div>
                              {/* <div
                                className="text-white cursor-pointer text-lg font-medium"
                                // onClick={() => {
                                //   if (location.pathname != "/") {
                                //     navigate("/fitnessage");
                                //     return;
                                //   }

                                //   setShowFullHeaderMenu(false);
                                // }}
                                onClick={() => {
                                  navigate("/fitnessage");
                                  setShowFullHeaderMenu(false);
                                  return;
                                }}
                              >
                                Fitness age
                              </div> */}

                              <div className="flex flex-1"></div>
                              <div
                                className="text-black text-center cursor-pointer text-sm rounded bg-primary-neonGreen px-5 py-2"
                                onClick={() => {
                                  setShowFullHeaderMenu(false);
                                  setClickFrom("nav_login");
                                  trackingPoint();
                                }}
                              >
                                Login
                              </div>
                            </div>
                          </div>
                        </Transition.Child>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </div>
            </Dialog>
          </Transition.Root>
        </>
      ) : (
        <div className="flex flex-1 flex-row h-full">
          <div className="flex flex-1" />
          <div
            // className="w-full grid lg:grid-cols-2 lg:gap-0 gap-4 sm:grid-cols-1 bg-[#040405] lg:px-24 lg:py-4 px-10 py-2"
            className="md:flex md:flex-rows justify-center lg:px-24 px-10 py-5 hidden "
          >
            <div
              className="flex flex-row lg:justify-center justify-center items-center lg:space-x-3 space-x-4"
              id="user-details-header"
            >
              <p className="flex space-x-1">
                <span>
                  <Icon
                    icon="ic:round-access-time-filled"
                    className="h-6 w-auto text-[#FE654F]"
                  />
                </span>
                <span className="text-sm text-white text-light sm:flex sm:justify-center sm:items-center">
                  {profile.timespent} mins
                </span>
              </p>
              <p className="flex space-x-2">
                <span>
                  <Icon
                    icon="healthicons:exercise-negative"
                    className="h-5 w-auto text-[#FE654F] rounded-full"
                  />
                </span>
                <span className="text-sm text-white text-light sm:flex sm:justify-center sm:items-center">
                  {profile.exe_done} exercises
                </span>
              </p>
              <p className="flex space-x-1">
                <span>
                  <Icon
                    // icon="bi:lightning-fill"
                    icon="mdi:lightning-bolt-circle"
                    className="h-6 w-auto text-[#FE654F]"
                  />
                </span>
                <span className="text-sm text-white text-light sm:flex sm:justify-center sm:items-center">
                  {profile.streak} streaks
                </span>
              </p>
              {/* <div className="flex justify-end  col-2 text-xs text-white md:pr-4 mr-2"> <span>2</span></div> */}
            </div>
          </div>
          <div className="flex flex-1" />
          <div className="hidden lg:block ">
            <div className=" flex justify-end flex-row space-x-10 h-full ">
              <Popover className={"relative focus:outline-none h-full"}>
                <Popover.Button className={"h-full"}>
                  <div className="h-full space-x-3 dark:text-primary-white text-xl flex items-center justtify-center font-medium">
                    {/* <HeaderElement title={selected} /> */}
                    <div
                      className="flex flex-row space-x-2"
                      id="hamburger-menu"
                    >
                      <p className="text-primary-neonGreen font-normal text-lg font-open-sans uppercase">
                        {modifiedSegment}
                      </p>
                      <Icon
                        // icon="ci:hamburger"
                        icon="ri:arrow-drop-down-line"
                        className="flex align-middle text-primary-neonGreen w-8 h-8"
                        onClick={() => {
                          setShowFullHeaderMenu(true);
                        }}
                      />
                    </div>
                  </div>
                </Popover.Button>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-200"
                  enterFrom="opacity-0 translate-y-0"
                  enterTo="opacity-100 translate-y-1"
                  leave="transition ease-in duration-150"
                  leaveFrom="opacity-100 translate-y-1"
                  leaveTo="opacity-0 translate-y-0"
                >
                  <Popover.Panel
                    className={`absolute z-20 w-48 mt-3 -ml-12 focus:outline-none py-3 flex flex-col shadow-3xl ${WhiteLinearGradient} rounded-xl`}
                  >
                    {({ close }) => (
                      <div className="flex flex-col space-y-4 ">
                        <div className="hover:cursor-pointer hover:bg-[#B2DE3E]  text-white flex justify-center items-center ">
                          <HeaderElement
                            icon={ic_exercise}
                            iconSelected={ic_exercise_red}
                            selectionPage={"/programpage"}
                            title="Workouts"
                            onClick={() => {
                              navigate("programpage");
                              setSelected(true);
                              close();
                            }}
                          />
                        </div>
                        <div className="hover:cursor-pointer hover:bg-[#B2DE3E] hover:text-[#1E1E1E] text-[#E6E6E6] flex justify-center items-center">
                          <HeaderElement
                            icon={ic_exercise}
                            iconSelected={ic_exercise_red}
                            selectionPage={"/routines"}
                            title="Routines"
                            onClick={() => {
                              navigate("routines");
                              setSelected(true);
                              close();
                            }}
                          />
                        </div>
                        <div className="hover:cursor-pointer hover:bg-[#B2DE3E] hover:text-[#1E1E1E] text-[#E6E6E6] flex justify-center items-center">
                          <HeaderElement
                            icon={ic_exercise}
                            iconSelected={ic_exercise_red}
                            selectionPage={"/practice"}
                            title="Exercises"
                            onClick={() => {
                              navigate("practice");
                              setSelected(true);
                              close();
                            }}
                          />
                        </div>
                        <div className="hover:cursor-pointer hover:bg-[#B2DE3E] hover:text-[#1E1E1E] text-[#E6E6E6] flex justify-center items-center">
                          <HeaderElement
                            icon={ic_exercise}
                            iconSelected={ic_exercise_red}
                            selectionPage={"/performance"}
                            title="Performance"
                            onClick={() => {
                              navigate("performance");
                              setSelected(true);
                              close();
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </Popover.Panel>
                </Transition>
              </Popover>

              {/* <form className="w-full py-2">
                <select
                  className={`w-full space-x-2 text-white text-xl font-light border-[2px] border-[#25272D] bg-[#2C2C32] rounded-lg items-center px-5 py-4`}
                  onChange={(e) => {
                    setAnswer(e.target.value);
                  }}
                  value={answer}
                >
                  <option
                    className={`absolute z-20 w-48 mt-3 -ml-32 focus:outline-none py-3 flex flex-col shadow-3xl ${WhiteLinearGradient} rounded-xl`}
                  >
                    <div className="hover:cursor-pointer hover:bg-primary-neonGreen hover:text-primary-black flex justify-center items-center">
                      <HeaderElement
                        icon={ic_exercise}
                        iconSelected={ic_exercise_red}
                        selectionPage={"/programpage"}
                        title="Workout"
                        onClick={() => {
                          navigate("programpage");
                        }}
                      />
                    </div>
                    <div className="hover:cursor-pointer hover:bg-primary-neonGreen hover:text-primary-black flex justify-center items-center">
                      <HeaderElement
                        icon={ic_exercise}
                        iconSelected={ic_exercise_red}
                        selectionPage={"/routines"}
                        title="Routines"
                        onClick={() => {
                          navigate("routines");
                        }}
                      />
                    </div>
                    <div className="hover:cursor-pointer hover:bg-primary-neonGreen hover:text-primary-black flex justify-center items-center">
                      <HeaderElement
                        icon={ic_exercise}
                        iconSelected={ic_exercise_red}
                        selectionPage={"/practice"}
                        title="Exercises"
                        onClick={() => {
                          navigate("practice");
                        }}
                      />
                    </div>
                    <div className="hover:cursor-pointer hover:bg-primary-neonGreen hover:text-primary-black flex justify-center items-center">
                      <HeaderElement
                        icon={ic_exercise}
                        iconSelected={ic_exercise_red}
                        selectionPage={"/performance"}
                        title="Performance"
                        onClick={() => {
                          navigate("performance");
                        }}
                      />
                    </div>
                    
                  </option>
                  {squad?.map((name) => (
                    <option value={name}>{name}</option>
                ))}
                </select>
              </form> */}

              {/* <HeaderElement
                icon={ic_exercise}
                iconSelected={ic_exercise_red}
                selectionPage={"/programpage"}
                title="Programs"
                onClick={() => {
                  navigate("programpage");
                }}
              />
              <HeaderElement
                icon={ic_exercise}
                iconSelected={ic_exercise_red}
                selectionPage={"/routines"}
                title="Routines"
                onClick={() => {
                  navigate("routines");
                }}
              />
              <HeaderElement
                icon={ic_exercise}
                iconSelected={ic_exercise_red}
                selectionPage={"/practice"}
                title="Exercises"
                onClick={() => {
                  navigate("practice");
                }}
              />
              <HeaderElement
                icon={ic_exercise}
                iconSelected={ic_exercise_red}
                selectionPage={"/performance"}
                title="Performance"
                onClick={() => {
                  navigate("performance");
                }}
              /> */}
              {/* <HeaderElement
                icon={ic_exercise}
                iconSelected={ic_exercise_red}
                selectionPage={"/subscription"}
                title="Pricing"
                onClick={() => {
                  navigate("subscription");
                }}
              /> */}
              <Popover className={"relative focus:outline-none h-full"}>
                <Popover.Button className={"h-full"}>
                  <button
                    className={`${
                      location.pathname == "/profile"
                      // ? "text-primary-blue border-primary-blue  dark:border-primary-white"
                      // : "border-primary-white text-primary-lightBlue dark:border-primary-darkBlue"
                    } h-full border-none space-x-3 dark:text-primary-white text-xl flex items-center justtify-center font-medium `}
                  >
                    {auth.state.user?.avatar ? (
                      <img
                        src={auth.state.user?.avatar}
                        className="rounded-full h-10 object-cover w-10"
                      />
                    ) : (
                      <div
                        // className={`${BlueLinearGradient} rounded-full h-10 w-10 flex items-center justify-center`}
                        id="profile-header"
                      >
                        <Icon icon="gg:profile" className="h-8 w-8 " />
                        {/* <p
                          className={`font-medium text-2xl ${WhiteTextLinearGradient}`}
                        >
                          {auth.state.user?.fullname
                            ? auth.state.user?.fullname[0]
                            : ""}
                        </p> */}
                      </div>
                    )}

                    {/* {
                      <p className={`focus:outline-none`}>
                        {auth.state.user?.fullname}
                      </p>
                    } */}
                    {/* <Icon
                      icon={"akar-icons:chevron-down"}
                      className={`dark:text-primary-white text-primary-lightBlue h-4 w-auto`}
                    /> */}
                  </button>
                </Popover.Button>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-200"
                  enterFrom="opacity-0 translate-y-0"
                  enterTo="opacity-100 translate-y-1"
                  leave="transition ease-in duration-150"
                  leaveFrom="opacity-100 translate-y-1"
                  leaveTo="opacity-0 translate-y-0"
                >
                  <Popover.Panel
                    className={`absolute z-20 w-80 mt-3 -ml-44 focus:outline-none py-6 flex flex-col shadow-3xl ${WhiteLinearGradient} rounded-xl`}
                  >
                    {({ close }) => (
                      <div className="flex flex-col">
                        <div className="flex flex-col items-center space-y-2">
                          {auth.state.user?.avatar ? (
                            <img
                              src={auth.state.user?.avatar}
                              className="rounded-full h-24 object-cover w-24"
                            />
                          ) : (
                            <div
                              className={`${BlueLinearGradient} rounded-full h-24 w-24 flex items-center justify-center`}
                            >
                              <p
                                className={`font-medium text-4xl ${WhiteTextLinearGradient}`}
                              >
                                {auth.state.user?.fullname[0]}
                              </p>
                            </div>
                          )}

                          <p
                            className={`focus:outline-none font-medium text-xl ${BlueTextLinearGradient}`}
                          >
                            {auth.state.user?.fullname}
                          </p>
                          <p
                            className={`focus:outline-none font-medium text-primary-gray`}
                          >
                            {auth.state.user?.email}
                          </p>
                        </div>
                        <div className="h-[1px] bg-[#C4C4C480] my-4"></div>
                        <div className="space-y-4 px-12 mt-3">
                          <div
                            className="flex flex-row items-center hover:cursor-pointer"
                            onClick={() => {
                              navigate("profile");
                              close();
                            }}
                          >
                            <Icon
                              icon="bi:person"
                              className="h-5 text-primary-gray"
                            />
                            <p className="font-medium pl-4 text-sm text-primary-gray flex-1 uppercase">
                              My Profile
                            </p>
                          </div>
                          <div
                            className="flex flex-row items-center hover:cursor-pointer"
                            onClick={() => {
                              navigate("settings");
                              close();
                            }}
                          >
                            <Icon
                              icon="ri:money-dollar-circle-fill"
                              className="h-8 text-primary-gray"
                            />
                            <p className="font-medium pl-4 text-sm text-primary-gray flex-1 uppercase">
                              billing
                            </p>
                          </div>
                          <div
                            className="flex flex-row items-center hover:cursor-pointer"
                            onClick={() => {
                              if (appState.state.darkMode)
                                appState.toggleDarkMode();
                              auth.logout();
                              close();
                              navigate("/");
                              // toast("Logout Successful");
                            }}
                          >
                            <Icon
                              icon="ic:round-logout"
                              className="h-5 text-[#FF3F3F]"
                            />
                            <p className="font-medium pl-4 text-sm text-[#FF3F3F] flex-1 uppercase">
                              Logout
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </Popover.Panel>
                </Transition>
              </Popover>
              {/* <Icon
                icon={
                  appState.state.darkMode ? "clarity:sun-line" : "carbon:moon"
                }
                className=" h-5 w-auto self-center cursor-pointer"
                color={appState.state.darkMode ? "#fff" : "#0B28AC"}
                onClick={() => {
                  appState.toggleDarkMode();
                }}
              /> */}
              {/* <p className="flex items-center font-medium text-xl text-primary-white flex-1 -mt-1">
            <a href="/subscription">Pricing</a>
          </p> */}
            </div>
          </div>

          <div
            // id="profile-header"
            className="lg:hidden flex flex-row gap-5"
          >
            {/* <HeaderElement
              icon={ic_plans}
              iconSelected={ic_plans_red}
              selectionPage={"/subscription"}
              title="Plans"
              onClick={() => {
                navigate("subscription");
              }}
            /> */}
            {/* <Icon
              icon={
                appState.state.darkMode ? "clarity:sun-line" : "carbon:moon"
              }
              className=" h-5 w-auto self-center cursor-pointer"
              color={appState.state.darkMode ? "#fff" : "#0B28AC"}
              onClick={() => {
                appState.toggleDarkMode();
              }}
            /> */}
            <Popover className={"relative focus:outline-none"}>
              <Popover.Button className={"h-full"}>
                <Icon
                  icon="gg:profile"
                  className="flex justify-center items-center h-8 w-8 text-primary-white"
                />
                {/* <IconButton
                  icon={null}
                  iconEnd={chevron_down}
                  text={null}
                  className="flex justify-center items-center"
                /> */}
              </Popover.Button>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-0"
                enterTo="opacity-100 translate-y-1"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-1"
                leaveTo="opacity-0 translate-y-0"
              >
                <Popover.Panel
                  className={`absolute z-20 w-80 mt-3 -ml-72 focus:outline-none py-6 flex flex-col shadow-3xl ${WhiteLinearGradient} rounded-xl`}
                >
                  {({ close }) => (
                    <div className="flex flex-col">
                      {auth.state.user && (
                        <div className="flex flex-col items-center space-y-2">
                          {auth.state.user?.avatar ? (
                            <img
                              src={auth.state.user?.avatar}
                              className="rounded-full h-24 object-cover w-24"
                            />
                          ) : (
                            <div
                              className={`${BlueLinearGradient} rounded-full h-24 w-24 flex items-center justify-center`}
                            >
                              <p
                                className={`font-medium text-4xl ${WhiteTextLinearGradient}`}
                              >
                                {auth.state.user?.fullname[0]}
                              </p>
                            </div>
                          )}

                          <p
                            className={`focus:outline-none font-medium text-xl ${BlueTextLinearGradient}`}
                          >
                            {auth.state.user?.fullname}
                          </p>
                          <p
                            className={`focus:outline-none font-medium text-primary-gray`}
                          >
                            {auth.state.user?.email}
                          </p>
                        </div>
                      )}
                      <div className="h-[1px] bg-[#C4C4C480] my-4"></div>
                      <div className="space-y-4 px-12 mt-3">
                        <div
                          className="flex flex-row items-center hover:cursor-pointer"
                          onClick={() => {
                            navigate("profile");
                            close();
                          }}
                        >
                          <p className="font-medium pl-4 text-sm text-primary-gray flex-1 uppercase">
                            My Profile
                          </p>
                        </div>
                        <div
                          className="flex flex-row items-center hover:cursor-pointer"
                          onClick={() => {
                            // navigate("exercise");
                            navigate("programpage");
                            close();
                          }}
                        >
                          <p className="font-medium pl-4 text-sm text-primary-gray flex-1 uppercase">
                            {/* Programs */}
                            Workouts
                          </p>
                        </div>
                        <div
                          className="flex flex-row items-center hover:cursor-pointer"
                          onClick={() => {
                            navigate("routines");
                            close();
                          }}
                        >
                          <p className="font-medium pl-4 text-sm text-primary-gray flex-1 uppercase">
                            Routines
                          </p>
                        </div>
                        <div
                          className="flex flex-row items-center hover:cursor-pointer"
                          onClick={() => {
                            navigate("practice");
                            close();
                          }}
                        >
                          <p className="font-medium pl-4 text-sm text-primary-gray flex-1 uppercase">
                            Exercises
                          </p>
                        </div>
                        <div
                          className="flex flex-row items-center hover:cursor-pointer"
                          onClick={() => {
                            navigate("performance");
                            close();
                          }}
                        >
                          <p className="font-medium pl-4 text-sm text-primary-gray flex-1 uppercase">
                            Performance
                          </p>
                        </div>
                        {/* <div
                          className="flex flex-row items-center hover:cursor-pointer"
                          onClick={() => {
                            navigate("subscription");
                            close();
                          }}
                        >
                          <p className="font-medium pl-4 text-sm text-primary-gray flex-1 uppercase">
                          Billing
                        
                          </p>
                        </div> */}
                        <div
                          className="flex flex-row items-center hover:cursor-pointer"
                          onClick={() => {
                            navigate("settings");
                            close();
                          }}
                        >
                          <p className="font-medium pl-4 text-sm text-primary-gray flex-1 uppercase">
                            Billing
                          </p>
                        </div>
                        <div
                          className="flex flex-row items-center hover:cursor-pointer"
                          onClick={() => {
                            if (appState.state.darkMode)
                              appState.toggleDarkMode();
                            auth.logout();
                            close();
                            navigate("/");
                            // toast("Logout Successful");
                          }}
                        >
                          <p className="font-medium pl-4 text-sm text-[#FF3F3F] flex-1 uppercase">
                            Logout
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </Popover.Panel>
              </Transition>
            </Popover>
          </div>
        </div>
      )}

      <AuthDialog open={showAuthDialog} setOpen={setShowAuthDialog} />
    </div>
  );
}

export default Header;
